export const firebaseRoutes = {
  homePage: 'https://pixeon-id-admin-default-rtdb.firebaseio.com/home-page-text.json',
  cultura: 'https://pixeon-id-admin-default-rtdb.firebaseio.com/cultura.json',
  pessoas: 'https://pixeon-id-admin-default-rtdb.firebaseio.com/pessoas.json',
  historia: 'https://pixeon-id-admin-default-rtdb.firebaseio.com/historia.json',
  integridade: 'https://pixeon-id-admin-default-rtdb.firebaseio.com/integridade.json',
  estrutura: 'https://pixeon-id-admin-default-rtdb.firebaseio.com/estrutura.json',
  educa: 'https://pixeon-id-admin-default-rtdb.firebaseio.com/educa.json',
  solucoes: 'https://pixeon-id-admin-default-rtdb.firebaseio.com/solucoes.json',
  okrs: 'https://pixeon-id-admin-default-rtdb.firebaseio.com/okrs.json',
  dna: 'https://pixeon-id-admin-default-rtdb.firebaseio.com/dna.json'
}
